/**
 * FirstVisitHints — the onboarding carousel's replacement (NPE-1, see
 * docs/planning/NPE-Redesign.md §B). Two non-blocking pills shown the
 * first time a player stands in the walkable waiting room, sequenced,
 * then never again. Never intercepts input.
 */
import { useEffect, useState } from 'react';

const HINTS_KEY = 'tt:hintsV1';

function coarsePointer(): boolean {
  try { return window.matchMedia('(pointer: coarse)').matches; } catch { return false; }
}

export function FirstVisitHints() {
  const [phase, setPhase] = useState<0 | 1 | 2>(() => {
    try { return localStorage.getItem(HINTS_KEY) ? 2 : 0; } catch { return 2; }
  });

  useEffect(() => {
    if (phase === 2) return;
    // Pill 1 for 6s, pill 2 for 6s, then done for good.
    const t = window.setTimeout(() => {
      if (phase === 0) { setPhase(1); return; }
      try { localStorage.setItem(HINTS_KEY, '1'); } catch { /* */ }
      setPhase(2);
    }, 6000);
    return () => window.clearTimeout(t);
  }, [phase]);

  if (phase === 2) return null;
  const text = phase === 0
    ? (coarsePointer() ? 'Drag anywhere to walk' : 'WASD or drag to walk')
    : 'Gather at the table — vote for a game';
  return (
    <div className="hall-hint-layer" aria-hidden="true">
      <div key={phase} className="hall-hint-pill">{text}</div>
    </div>
  );
}
